import districtNames from "../data/odishaDistrictNames.json";

const normalizeDistrictToken = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");

const byToken = new Map();
districtNames.forEach((entry) => {
  [entry.name, entry.slug, ...(entry.aliases || [])].forEach((value) => {
    const token = normalizeDistrictToken(value);
    if (token) byToken.set(token, entry);
  });
});

export const resolveOdishaDistrict = (value) => byToken.get(normalizeDistrictToken(value)) || null;

export const canonicalizeDistrictName = (value) => {
  const entry = resolveOdishaDistrict(value);
  return entry?.name || String(value || "").trim();
};

export const canonicalizeDistrictSlug = (value) => {
  const entry = resolveOdishaDistrict(value);
  return entry?.slug || normalizeDistrictToken(value);
};

export { districtNames, normalizeDistrictToken };

